export default "__VITE_ASSET__DgLKzw_R__"